import React from "react";
import "./Projetos.css";
import { Link } from "react-router-dom";
// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

// Imagens
import recupAreaDegradada from "../../assets/img/projetos/recupAreaDegradada2.png";
import licenciamento from "../../assets/img/projetos/licenciamento1.png";
import progEduAmb3 from "../../assets/img/projetos/progEduAmb3.png";
import gerecResSol1 from "../../assets/img/projetos/gerecResSol1.png";

import BotaoContatoOutline from "../../componentes/BotaoContatoOutline/BotaoContatoOutline";

export default function SecaoProjetos() {
  const projetos = [
    {
      img: licenciamento,
      categoria: "Segurança Operacional",
      titulo: "Licenciamento Ambiental",
      link: "/projetos/licenciamento-ambiental",
    },
    {
      img: recupAreaDegradada,
      categoria: "Restauração de Áreas",
      titulo: "Projeto de Recuperação de Áreas Degradadas(PRAD)",
      link: "/projetos/recuperacao-de-areas-degradadas",
    },
    // {
    //   img: progEduAmb3,
    //   categoria: "Sustentabilidade e ESG",
    //   titulo: "Programa de Educação Ambiental(PEA)",
    //   link: "/projetos/programa-de-educacao-ambiental",
    // },
    {
      img: gerecResSol1,
      categoria: "Resíduos sólidos",
      titulo: "Gerenciamento de Resíduos Sólidos",
      link: "/projetos/gerenciamento-de-residuos-solidos",
    }
  ];

  return (
    <section className="projetos-wrapper py-5" id="projetos">
      <div className="container text-center projetos">
        <h2 className="titulo-secao text-center scroll-reveal-zoom">
          Projetos em Destaque
          <span className="barra"></span>
        </h2>

        <p className="desc mb-5 scroll-reveal-zoom">
          Uma demonstração de impacto e qualidade dos nossos serviços.
        </p>

        {/* CARROSSEL SWIPER */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={true}
          pagination={{ clickable: true }}
          spaceBetween={40}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 1 },
            992: { slidesPerView: 2 },
          }}
          className="projetos-carousel"
        >
          {projetos.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="card h-100 card-projeto scroll-reveal-zoom">
                <img
                  src={item.img}
                  alt={item.titulo}
                  className="card-img-top projeto-img"
                />
                <div className="card-body">
                  <p className="categoria">{item.categoria}</p>
                  <h5 className="card-title">{item.titulo}</h5>

                  <Link to={item.link} className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* <div className="mt-5 btn-contato-wrapper scroll-reveal-zoom">
          <BotaoContatoOutline texto="Ver Portfólio Completo" rota="/" />
        </div> */}
      </div>
    </section>
  );
}
